export default {
  meta: {
    title: '蜜雪选址地图',
  }
};
